import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { AddressModule } from '@shared/address/address.module';
import { IdentifierUpdateModule } from '@shared/identifier-update/identifier-update.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { CardStepBodyComponent, EntityBondComponent, EntityUnifyCardComponent, EntityUnifyUpdateComponent } from './components';
import { BondEditFormComponent } from './components/bond-edit-form/bond-edit-form.component';
import { RouterModule } from '@angular/router';
import { BillSharedModule } from '@shared/bill-shared/bill-shared.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [CardStepBodyComponent, EntityBondComponent, EntityUnifyCardComponent, EntityUnifyUpdateComponent, BondEditFormComponent],
  imports: [
    CommonModule,
    MutualModule,
    AddressModule,
    IdentifierUpdateModule,
    BsDropdownModule.forRoot(),
    ModalModule,
    BsDatepickerModule,
    PipesSharedModule,
    InputPhoneModule,
    FormWrapperModule,
    NgxIntlTelInputModule,
    RouterModule,
    BillSharedModule,
    CustomModalModule,
  ],
  exports: [CardStepBodyComponent, EntityBondComponent, EntityUnifyCardComponent, EntityUnifyUpdateComponent, BondEditFormComponent],
})
export class EntityModule {}
